import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=262130c9&"
import script from "./LabelForm.vue?vue&type=script&lang=ts&"
export * from "./LabelForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports